<template>
  <DynamicDialog
    v-model:show="dialog"
    max-width="600px"
    cancelBtnVariant="text"
    cancelBtnColor="none"
    :okBtnHidden="true"
  >
    <template v-slot:title>Invitation link</template>
    <template v-slot:content>
      <div>
        <v-alert color="info" class="mb-5" rounded="0">
          If the user doesn’t receive the invitation email, you can copy the
          link below and send it to them directly. This link will no longer be
          visible once you close this window, unless you click ‘Resend invite’
          button.
        </v-alert>
        <v-text-field
          v-model="link"
          label="Invitation link"
          readonly
          density="compact"
          rounded="0"
          variant="outlined"
          :append-icon="isLinkCopied ? 'mdi-check' : 'mdi-content-copy'"
          label:append-icon="Click to Copy Link"
          @click:append="copyLink"
          persistent-hint
          :hint="clipboardMessage"
        ></v-text-field>
      </div>
    </template>
    <template v-slot:cancelBtnTitle>CLOSE</template>
  </DynamicDialog>
</template>

<script>
import { copyToClipboard } from "@/mixins/CopyToClipboard";

import DynamicDialog from "@/components/DynamicDialog.vue";
export default {
  name: "ShowUserInvitationLink",
  data: () => ({
    clipboardMessage: "",
    isLinkCopied: false,
  }),
  components: { DynamicDialog },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    // recipient: {},
    invitationLink: {
      type: String,
      required: true,
      default: "",
    },
  },
  computed: {
    dialog: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
    link: {
      get() {
        return this.invitationLink;
      },
      set(val) {
        this.$emit("update:invitationLink", val);
      },
    },
  },
  methods: {
    copyLink() {
      if (copyToClipboard(this.link)) {
        this.clipboardMessage = "The link has been copied to your clipboard";
        this.isLinkCopied = true;
      } else {
        this.clipboardMessage =
          "Something went wrong, please manually copy the link";
      }

      // clear the message after 3 seconds
      setTimeout(() => {
        this.clipboardMessage = "";
        this.isLinkCopied = false;
      }, 3000);
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.link = "";
      }
    },
  },
};
</script>

<style scoped></style>
